import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    web3:null,
    account:"",
    contract:false,
    members:[]
  },
  getters:{
    web3:(state)=>state.web3,
    account:(state)=>state.account,
    contract:(state)=>state.contract,
    net_members:(state)=>state.members
  },
  mutations: {
    set_web3:(state,webmodule)=>{
      if(!state.web3)
        state.web3 = webmodule
    },
    set_account:(state,account)=>{
      state.account = account;
    },
    set_contract:(state)=>{
      state.contract = true;
    },
    set_members:(state,members)=>{
      state.members = members;
    }
  },
  actions: {
    set_web3:({commit},webmodule)=>{commit('set_web3',webmodule)},
    set_account:({commit},account)=>{commit('set_account',account)},
    set_contract:({commit})=>{commit('set_contract')},
    set_members:({commit},members)=>{commit('set_members',members)},
    fetch_data:(para)=>{}
  },
});
